@for (level of levels; track $index; let currentLevel = $index) {
  <div>
    @if (showLevels) {
      @for (bu of level; track bu) {
        <div
          class="level">
          @for (dot of [].constructor(currentLevel + 1); track $index) {
            <div
              class="dot"></div>
          }
          <div class="spacer"></div>
          <div class="controls">
            <reporter-icon
              class="mr-2"
              [icon]="bu.hasChildren ? ((selected?.id === bu.id && !!children?.length) ? 'Expanded' : 'Collapsed') :
               'Leaf'"
              [cursorPointer]="bu.hasChildren"
              (click)="select(bu, currentLevel)">
            </reporter-icon>
          </div>
          <div class="col">
            <div class="d-flex align-middle justify-content-between">
              <div>
                @if (systemClientSelected && bu.displayName?.toUpperCase() !== 'SYSTEM') {
                  <span>
                    {{ '[' + bu.gbClientNumber + ']' }}
                  </span>
                }
                <span [innerHTML]="highlightText(bu.displayName)"></span>
              </div>
              @if ((reportingCapable && bu.reportingLocation) || !reportingCapable) {
                <button type="button"
                        class="btn btn-action py-0"
                        [class.cursor-not-allowed]="reportingCapable && !bu.reportingLocation"
                        (click)="emitSelected(bu)">
                  Select
                </button>
              }
            </div>
            @if (bu.displayName?.toUpperCase() !== 'SYSTEM') {
              <reporter-business-unit-details
                [showClientNumber]="systemClientSelected"
                [buDetails]="bu"
                [buReferenceNumberPrompt]="buReferenceNumberPrompt"
                [searchTerm]="searchTerm">
              </reporter-business-unit-details>
            }
          </div>
        </div>
      }
    }
  </div>
}
@if (selected?.id) {
  <div class="filter px-2">
    <div class="search-box d-flex align-baseline w-100">
      @for (dot of [].constructor(levels.length + 1); track $index) {
        <div
          class="dot"></div>
      }
      <div class="spacer"></div>
      <div class="label">Filter</div>
      <div class="ml-2 mr-4 col px-0">
        <form (ngSubmit)="refineSearch()"
              (reset)="refineSearch()">
          <div class="input-group">
            <input name="searchFieldValue"
                   placeholder="Enter text to refine results"
                   type="text"
                   class="form-control"
                   [(ngModel)]="searchFieldValue">
            <div class="input-group-append">
              <button class="clear-search-input"
                      type="reset"
                      [hidden]="!searchTerm"
                      (click)="searchFieldValue = undefined; ">
                <i class="fas fa-times-circle"></i>
              </button>
              <button type="submit"
                      class="btn btn-action py-0">
                <reporter-icon icon="CheckMarkWhite"></reporter-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="children"
       infiniteScroll
       [scrollWindow]="false"
       [infiniteScrollDistance]="2"
       [infiniteScrollThrottle]="100"
       [infiniteScrollDisabled]="totalPages < pageNumber"
       (scrolled)="loadChildren()"
       [style]="{'height': 'calc(100% - ' + (levels.length * 2) + 'rem - 2.5rem) !important' }">
    @for (child of children; track child) {
      <div
        class="list-group-item"
        [class.in-focus]="inFocus?.id === child.id">
        <div class="controls">
          <reporter-icon
            class="mr-2"
            [icon]="child.hasChildren ? 'Collapsed' : 'Leaf'"
            [cursorPointer]="child.hasChildren"
            (click)="selectChild(child)">
          </reporter-icon>
        </div>
        <div class="reporting-location  col">
          <div class="d-flex align-middle justify-content-between">
            <div>
              @if (systemClientSelected) {
                <span style="font-weight: bold;">
                  {{ '[' + child.gbClientNumber + ']' }}
                </span>
              }
              <span [innerHTML]="highlightText(child.displayName)"></span>
            </div>
            @if ((reportingCapable && child.reportingLocation) || !reportingCapable) {
              <button
                type="button"
                class="btn btn-action py-0"
                [class.cursor-not-allowed]="reportingCapable && !child.reportingLocation"
                (click)="emitSelected(child)">
                Select
              </button>
            }

          </div>
          @if (true || child.id === buDetails?.id) {
            <reporter-business-unit-details
              [showClientNumber]="systemClientSelected"
              [buDetails]="child"
              [buReferenceNumberPrompt]="buReferenceNumberPrompt"
              [searchTerm]="searchTerm">
            </reporter-business-unit-details>
          }
        </div>
      </div>
    }
  </div>
}
